<script>
	import { onMount } from 'svelte';
	import { browser } from '$app/environment';
	import tpLogo from '$lib/assets/TP-Logo-Tricolor-Black-RGBOpt.png';
	import tpLogoWhite from '$lib/assets/TP-Logo-Tricolor-White-RGBOpt.png';

	export let showText;
	export let showAsRow = false;
	export let invertColour = false;

	// Local state to determine if we're in a native app environment
	
	// This flag ensures that the onMount code has executed before rendering anything
	let loaded = false;

	// Function to dynamically load external scripts
	function loadScript(src) {
		return new Promise((resolve, reject) => {
			// Check if the script is already loaded
			if (document.querySelector(`script[src="${src}"]`)) {
				resolve();
				return;
			}
			const script = document.createElement('script');
			script.src = src;
			script.async = true;
			script.defer = true;
			script.onload = () => resolve();
			script.onerror = () => reject(new Error(`Failed to load script: ${src}`));
			document.body.appendChild(script);
		});
	}

	onMount(async () => {
		if (!browser) return;

		try {
			// Load the external widget script
			await loadScript('https://grwapi.net/widget.min.js');
			// If needed, initialize the widget here, e.g.:
			// if (window.GRW && typeof window.GRW.initWidgets === 'function') {
			//     window.GRW.initWidgets();
			// }
		} catch (error) {
			console.error('Error loading the widget script:', error);
		}

	
		// Mark as loaded so the UI can update
		loaded = true;
	});
</script>

{#if loaded}
	<div class={showAsRow ? 'tp-box-row reviews-box' : 'reviews-box tp-box-col'}>
		<div>
			<!-- Widget Container -->
			<div
				class="review-widget_net"
				data-uuid="9d4268d4-9c8e-4b8c-b72e-1eb11f033d51"
				data-template="2"
				data-lang="en"
				data-theme={invertColour ? 'dark' : 'light'}
			></div>

			{#if showText}
				<!-- Optional Text Section -->
				<!--
				<div>
					<h3>Rated <span>4.9</span></h3>
					<h5>Excellent</h5>
				</div>
				-->
			{/if}
		</div>

		<!-- Optional Trustpilot Section (Uncomment if needed) -->
		<!--
		<div>
			<a href="https://www.trustpilot.com/review/hotdraw.co.uk" target="_blank" rel="noopener noreferrer">
				<img src={invertColour ? tpLogoWhite : tpLogo} alt="Trustpilot logo" />
			</a>
		</div>
		-->
	</div>
{/if}

<style lang="scss">
	.reviews-box {
		z-index: 2;
		a,
		picture {
			display: block;
			text-align: center;
		}
		img {
			margin: auto;
			max-height: 60px;
		}
	}

	.tp-box-row {
		display: flex;
		align-items: center;
		flex-direction: row;
		justify-content: center;

		div {
			margin: 0 10px;
		}
	}
</style>
